import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {OutlinedInput, Select, MenuItem, FormControl } from '@mui/material';
// import Radio from '@mui/material/Radio';
// import Checkbox from '@mui/material/Checkbox';
// import FormControlLabel from '@mui/material/FormControlLabel';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress'; 
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import OverlayLoadingScreen from '../components/OverlayLoadingScreen';
import LeadDetails from './LeadDetails'; 
import LeadSave from './LeadSave';
import AgentSelect from '../agents/AgentSelect';
import AgentSelectMultiple from '../agents/AgentSelectMultiple';
///import LeadSaveEdit from './LeadSaveEdit';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const location = useLocation();
	Cookies.set('leadPageUrl', 'leads', { expires: new Date(new Date().getTime() + 3600000*24*5) });
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin'); 
	const childRefCaseDetails = React.useRef();
	const childRefSave = React.useRef(); 
	const childRefUser = React.useRef();
	const childRefAddUser = React.useRef();
	const childRefAuthorization = React.useRef();
	const [dataLoading, setDataLoading] = React.useState(true);
	const [overlayLoading, setOverlayLoading] = React.useState(false);
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(0);
	const [pageSize, setPageSize] = React.useState(100);
	const [privileges, setPrivileges] = React.useState("");
	const [status, setStatus] = React.useState("noselect");
	const [type, setType] = React.useState("noselect");
	const [filterType, setFilterType] = React.useState("noselect");
	const [channelId, setChannelId] = React.useState(0);
	const [channelList, setChannelList] = React.useState([]);
	const [leadTypeList, setLeadTypeList] = React.useState([]);
	const [leadStatusDataList, setLeadStatusDataList] = React.useState([]);
	const [leadStatusList, setLeadStatusList] = React.useState([]);
	const [selectedRows, setSelectedRows] = React.useState([]);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [caseObj, setCaseObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	const handlePageChange = (obj) => {
	//   alert("newPage: "+JSON.stringify(obj));
	  //DataGrid.UnselectAllCells();
	  setCaseObj({});
	  setSelectedRows([]);
	  setPageSize(obj.pageSize);
	  setPage(obj.page);
	  setFilter(!filter);
	};


	const columns = [
		{ field: 'srno', headerName: '#', width: 40 },
		{ field: 'leadNumber', headerName: 'Lead Number', width: 120, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'title', headerName: 'Title', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'leadType', headerName: 'Type', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
		{ field: 'amount', headerName: 'Amount', width: 160, renderCell: (params) =>  (
			<span>{params.value>0?params.value:null}</span>
		   ), },		   
		{ field: 'status', headerName: 'Status', width: 160, renderCell: (obj) =>  (
			<span>{obj.row.parentStatus==='Lost'?<>{obj.row.status}<br/>{obj.row.lossReason}</>:obj.row.status}</span>
		   ), },	
		{ field: 'parentStatus', headerName: 'Parent Status', width: 140 },
		{ field: 'rating', headerName: 'Rating', width: 100 },
		{ field: 'statusChangeDateTime', headerName: 'Status Change Date', width: 180 },	
		{ field: 'contactName', headerName: 'Contact Name', width: 180, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },	
		{ field: 'mobile', headerName: 'Mobile', width: 160, renderCell: (params) =>  (
			<>{(params.value && params.value.length>5)?<a href={'https://wa.me/'+params.value+'?text=Hello'} style={{textDecoration:'none'}} target='_blank' ><i className="fa fa-whatsapp whatsAppBtnColor"></i> {params.value}</a>:null}</>
		   ), },
		{ field: 'phone', headerName: 'Phone', width: 160 },
		{ field: 'address', headerName: 'Address', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },			
	    { field: 'pincode', headerName: 'Pincode', width: 160 },
		{ field: 'source', headerName: 'Source', width: 160 },
		{ field: 'industry', headerName: 'Industry', width: 160 },
		{ field: 'accountName', headerName: 'Account Name', width: 160 },
		{ field: 'partnerAccountName', headerName: 'Partner', width: 160 },
		{ field: 'channelName', headerName: 'Channel', width: 160 },
		{ field: 'remarks', headerName: 'Remarks', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'comment', headerName: 'Comment', width: 270, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), }, 
		{ field: 'ownerAlias', headerName: 'Agent', width: 160 },
		{ field: 'accessWithNames', headerName: 'Shared with', width: 160 },   
	  ];

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){			
			getApiData();
		}
	}, [userObj, filter, location]);

	async function getApiData(){ 
		  let queryString = '';
		  if(filterType && filterType!=='noselect'){
			queryString += '&filter='+filterType;
		  }else if(location && location.state && location.state.filter){
			queryString += '&filter='+location.state.filter;
			setFilterType(location.state.filter);
		  }
		  if(location && location.state && location.state.startDate){
			queryString += '&startDate='+location.state.startDate+'&endDate='+location.state.endDate;
		  }	
		  if(location && location.state && location.state.parentStatus){
			queryString += '&parentStatus='+location.state.parentStatus;
		  }	
		  if(status && status!=='noselect'){
			queryString += '&status='+status;
		  }
		  if(type && type!=='noselect'){
			queryString += '&leadType='+type;
		  } 
		  if(channelId && channelId>0){
			queryString += '&channelId='+channelId;
		  } 		  
		  let apiUrl=API_URL+'/crm-list-leads?search=1&minRows='+(page*pageSize)+'&maxRows='+pageSize+'&keyword='+keyword+queryString;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.status===200 && response.data && response.data.responseTxt==="success"){  
				 	if(page===0){
						setRowCount(response.data.rowCount);
					}
					setRows(response.data.list);	
					setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
	}

	React.useEffect(() => {
		if(userObj && userObj.registerId>0){		
			getApiDataMultiple();
		}
	}, [userObj]);

	async function getApiDataMultiple(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': userObj.registerId,
			'uid': userObj.loginId,
			'fullName': userObj.fullName,
			'token': userObj.token,
		  }
		};

			axios.get(API_URL+'/crmix-for-leadlist', axiosHeader)
			.then(response => {
			if(response && response.data && response.data.responseTxt==="success"){ 
				setChannelList(response.data.obj.leadChannels);
				setLeadStatusDataList(response.data.obj.leadStatus);
				setLeadTypeList(response.data.obj.leadTypes);

			}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				navigate('/invalidtoken');
			} 		 				
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})
	}

	
	function saveData(opt){
		if(opt===1){
			setCaseObj({});
			setSelectedRows([]);
			childRefSave.current.handleClickOpen();
		}else if(opt===2 && selectedRows && selectedRows.length>0){
			setCaseObj(rows[selectedRows[0]-1]);
			childRefSave.current.handleClickOpen();
		}else if(opt===3 && selectedRows && selectedRows.length>0){
			setCaseObj(rows[selectedRows[0]-1]);
			childRefCaseDetails.current.handleClickOpen();
		}
	}
	
	function deleteData(){
		if(selectedRows && selectedRows.length>0 && userObj.token){
			
			setDeleteDialogShow(false);

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

			let delRows="";
			if(selectedRows){
				for(let i=0; i<selectedRows.length; i++){
					delRows+=rows[selectedRows[i]-1]?.autoId+",";
				}
				delRows=delRows.substring(0,delRows.length-1);
				///alert("delRows=="+delRows);
			}

		  const data = new FormData();
		  //data.append('id', caseObj.autoId);
		  data.append('ids', delRows);
				 
		  axios.post(API_URL+'/crm-delete-leads', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Lead has been deleted.");
					setRows(response.data.list);	
					setCaseObj({});				
					setSelectedRows([]);
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This lead could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

	function selectUser(){
		childRefUser.current.handleClickOpen();
	}
	function addUser(){
		if(selectedRows && selectedRows.length>0){
			setCaseObj(rows[selectedRows[0]-1]);
			childRefAddUser.current.handleClickOpen();
		}
	}

	function transferLeadsToAgent(obj){

		if(selectedRows && selectedRows.length>0 && userObj.token){

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

			let selectedIds="";
			if(selectedRows){
				for(let i=0; i<selectedRows.length; i++){
					selectedIds+=rows[selectedRows[i]-1]?.autoId+",";
				}
				selectedIds=selectedIds.substring(0,selectedIds.length-1);
			}

		  const data = new FormData();
		  data.append('ownerId', obj.autoId);
		  data.append('ownerAlias', obj.fullName);
		  data.append('ids', selectedIds);
				 
		  setOverlayLoading(true);	
		  axios.post(API_URL+'/crm-transfer-leads', data, axiosHeader)
				.then((response) => {
					setOverlayLoading(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Lead has been transferred.");
					setFilter(!filter);	
					setCaseObj({});				
					setSelectedRows([]);
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Lead could not be transferred.");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("ERROR: " + error);
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

	
	function shareToAgent(ownerIds,ownerNames){

		if(selectedRows && selectedRows.length>0 && userObj.token){

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

			let selectedIds="";
			if(selectedRows){
				for(let i=0; i<selectedRows.length; i++){
					if(rows[selectedRows[i]-1] && rows[selectedRows[i]-1].autoId>0){
						selectedIds+=rows[selectedRows[i]-1].autoId+",";
					}
				}
				selectedIds=selectedIds.substring(0,selectedIds.length-1);
			}

		  const data = new FormData(); 
		  data.append('ownerIds', ownerIds);
		  data.append('ownerNames', ownerNames);
		  data.append('ids', selectedIds);
				 
		  setOverlayLoading(true);	
		  axios.post(API_URL+'/crm-share-leads', data, axiosHeader)
				.then((response) => {
					setOverlayLoading(false);
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Lead has been shared.");
					setFilter(!filter);	
					setCaseObj({});				
					setSelectedRows([]);
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Lead could not be shared.");			
					return false;
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage("ERROR: " + error);
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

	const handleOnCellClick = (obj) => { 
		if(obj.field==='leadNumber' || obj.field==='title'){
			setCaseObj(rows[obj.id-1]);			
			if(caseObj){
				childRefCaseDetails.current.handleClickOpen();
			} 
		}else if(obj.field==='accountName'){
			setCaseObj(rows[obj.id-1]);
			if(caseObj && caseObj.accountNumber){
				window.location="accountdetail?accountNumber="+caseObj.accountNumber;
			}
		}else if(obj.field==='mobile'){
			setCaseObj(rows[obj.id-1]);
			if(caseObj && caseObj?.mobile?.length>0){
				window.location="https://wa.me/"+caseObj?.mobile+"?text=Hello";
			}
		}		
	};

	function search(){
		setCaseObj({});
		setPage(0);
		setFilter(!filter);
		navigate(location.state, {}); // reset location param
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function handleFilterType(val) {
		setFilterType(val);
		search();
	}
	function handleType(val) {
		setType(val);
		search();
	}
	function handleStatus(val) {
		setStatus(val);
		search();
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function updatedList(list){
		setCaseObj({});
		setSelectedRows([]);
		setChannelId(0);
		setStatus("noselect");
		setType("noselect");
		setFilterType("noselect");
		setKeyword("");
		setRows(list);
	}

	function handleChannelId(id) {
		setChannelId(id);
		if(leadStatusDataList && leadStatusDataList.length>0 && id && id>0){

			let orderStatusArr = [];
			for(let i=0; i<leadStatusDataList.length; i++){
				if(leadStatusDataList[i].channelId===id){
					orderStatusArr.push(leadStatusDataList[i]);
				}
			}
			setLeadStatusList(orderStatusArr);

		}else{
			setLeadTypeList([]);
			setStatus("noselect");
			setLeadStatusList([]);
		}
		search();
	}



	return (
		<div> 
				<MetaTags>
            		<title>Leads</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Leads" />
				{dataLoading?<LinearProgress />:null}				
				<Box className='mainBox'>
				{/* selectedRows: {JSON.stringify(selectedRows)} */}
				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >
									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={channelId}
											onChange={event => handleChannelId(event.target.value)}
										>
											<MenuItem value={0}>All Channels</MenuItem>
											{channelList?channelList.map((myRow,mykey)=>(
												<MenuItem key={'ct'+mykey} value={myRow.autoId}>{myRow.channelName}</MenuItem>
											)):null}
										</Select> 
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={status}
											onChange={event => handleStatus(event.target.value)}
										>
											<MenuItem value={'noselect'}>All Status</MenuItem>
											{(leadStatusList && leadStatusList.length>0)?leadStatusList.map((myRow,mykey)=>(
												<MenuItem key={'ct'+mykey} value={myRow.status}>{myRow.status}</MenuItem>
											)):<MenuItem >Select Channel for status list</MenuItem>}
										</Select> 
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}} >
										<Select native
										 defaultValue={type} 
										 onChange={event => handleType(event.target.value)}
										 >
										<option value={'noselect'} >All Lead Type</option>
										{leadTypeList?leadTypeList.map((row,i)=>(
											<optgroup label={row.title} >
												{row.children?row.children.map((rw,j)=>(
													<option value={rw.id} >{rw.title}</option>
												)):null}
											</optgroup>
										)):null}
										</Select>
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={filterType}
											onChange={event => handleFilterType(event.target.value)}
										>
											<MenuItem value={'noselect'}>All Leads</MenuItem>
											<MenuItem value={'pipeline'}>Pipeline</MenuItem>
											<MenuItem value={'best-lead'}>Best-Lead</MenuItem>
											<MenuItem value={'committed'}>Committed Orders</MenuItem>
											<MenuItem value={'won'}>Won</MenuItem>
											<MenuItem value={'lost'}>Lost</MenuItem>
											<MenuItem value={'invalid'}>Invalid</MenuItem>
											<MenuItem value={'todayLeads'}>Today Leads</MenuItem>
											<MenuItem value={'thisMonthLeads'}>This Month Leads</MenuItem>
											<MenuItem value={'overdue'}>Overdue Follow-ups</MenuItem>
											<MenuItem value={'dueToday'}>Today Follow-ups</MenuItem>
											<MenuItem value={'dueTomorrow'}>Tomorrow Follow-ups</MenuItem>											
										</Select> 
									</FormControl>

									<FormControl style={{marginRight:4,marginBottom:4,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 size="small"
										 endAdornment={
											  <InputAdornment position="end">
												<SearchIcon />
											  </InputAdornment>
											}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:1,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>
									{userObj.packageId>1?<>		
										<i onClick={()=>{window.location='leadskanban'}} title="Leads Board" className="fa fa-trello btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null}	
										{(privileges && privileges.indexOf("create")>-1)?	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}	
									{(selectedRows && selectedRows.length>0)?<>
										{(privileges && ((privileges.indexOf("update")>-1 && userObj.userId===caseObj.ownerId) || privileges.indexOf("modifyall")>-1) )?<>	
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
											<i onClick={()=>{selectUser()}} title="Transfer Leads" className="fa fa-exchange btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
											<i onClick={()=>{addUser()}} title="Share with Agents" className="fa fa-users btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										</>:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />

									</>:null}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid							
							rows={rows?rows:[]}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}		
							pageSizeOptions={[25,50,100,200]}						
							paginationMode="server"
							onPaginationModelChange={handlePageChange}
  							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							//onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							checkboxSelection
							onRowSelectionModelChange={(newRowSelectionModel) => {
								setSelectedRows(newRowSelectionModel);
							  }}
							 rowSelectionModel={selectedRows}  
							slots={{
								noResultsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			<LeadSave dataObj={caseObj} userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefSave} />
			<LeadDetails caseObj={caseObj} privileges={privileges} userObj={userObj} ref={childRefCaseDetails}  />						
			<AgentSelect userObj={userObj} fetchDetail={transferLeadsToAgent} fetch={true} ref={childRefUser} />
			<AgentSelectMultiple userObj={userObj} dataObj={(selectedRows && selectedRows.length===1)?caseObj:{}} fetchDetail={shareToAgent} ref={childRefAddUser} />
			
			{overlayLoading?<OverlayLoadingScreen message="Please wait..." />:null}

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

			<Authorization ref={childRefAuthorization} />		
			
		</div>	
	);
  }